import React from 'react';

const EmailLink = ({ emailAddress, subject, body, children }) => {
  const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(subject || '')}&body=${encodeURIComponent(body || '')}`;

  return (
    <a href={mailtoLink} className="email-link">
      {children || emailAddress}
    </a>
  );
};

export default EmailLink;